import "./videosTable.css";
import {React, useState, useEffect} from "react";
import EditModal from "../editModal/editModal";
import RequestModal from "../requestModal/requestModal";
import { getContent, createVideos } from "../../services/content.js";
import {useNavigate} from "react-router-dom";

function VideosTable() {

    // dataTable
    const [dataTable, setDataTable] = useState([])

    // dataTable
    const [initData, setInitData] = useState([])

    //checked rows
    const [checkData, setCheckData] = useState([]);

    //field of selected row edit
    const [editRow, setEditRow] = useState([]);

    //open edit modal
    const [editModal, setEditModal] = useState(false);

    //open delete confirmation modal
    const [modal, setModal] = useState(false);

    // modal to inform the user if the request was successful
    const [txtMessage, setTxtMessage] = useState("");

    // modal button text
    const [buttonText, setButtonText] = useState("");

    const columns =
    [
        {
            header: 'Tag id',
            field: 'tag_id'
        },
        {
            header: 'Campaign id',
            field: 'campaign_id'
        },
        {
            header: 'Content',
            field: 'content'
        },
        // {
        //     header: 'Head content',
        //     field: 'head_content'
        // },
        {
            header: 'Selector',
            field: 'selector'
        },
        // {
        //     header: 'JS to inject',
        //     field: 'js_to_inject'
        // },
        {
            header: 'Inject type',
            field: 'inject_type'
        },
        {
            header: 'URL',
            field: 'url'
        },
        // {
        //     header: 'Ads txt',
        //     field: 'ads_txt'
        // },
        // {
        //     header: 'Missing lines',
        //     field: 'missing_lines'
        // }
    ];

    const navigate = useNavigate();


    //get videos data
    useEffect( () => {
        const itemStr = localStorage.getItem("loginToken");
        if (!itemStr) { //no cookie
            navigate('/');
        }
        else if (JSON.parse(itemStr).expiry < Date.now()) {
            localStorage.removeItem("loginToken");
            navigate('/');
        }
        async function fetchData() {
            const reqData = await getContent();
            setInitData(reqData)
            setDataTable(reqData);
        }
        fetchData();
    }, []);

    const sortTable = (e, columnName) => {
        var sortData = dataTable;
        var order = e.target.attributes['name'].nodeValue;
        if (order === 'ASC') {
            sortData.sort((a, b) => (a[columnName] > b[columnName] ? 1 : a[columnName] < b[columnName] ? -1 : 0));
        }
        if (order === 'DESC') {
            sortData.sort((a, b) => (a[columnName] > b[columnName] ? -1 : a[columnName] < b[columnName] ? 1 : 0));
        }
        setDataTable([...sortData]);
    }

    // filter rows depende on search feild's value
    const filterTable = (e) => {
        let filterData = [];
        let i = 0, j = 0;
        let value = e.target.value.toUpperCase();
        const headers = [];
        if (value === ""){
            setDataTable(initData);
            return;
        }
        for (i; i < columns.length; i++) {
            headers.push(columns[i].field)
        }
        i=0;
        for( i; i < dataTable.length;i++){
            j=0;
            for ( j; j < headers.length; j++){
                if (dataTable[i][headers[j]] !== null) {
                    const cell = dataTable[i][headers[j]].toString().toUpperCase();
                    // show only rows that contain the value that insert in the search field
                    if ( cell.includes(value)){
                        filterData.push(dataTable[i]);
                        break;
                    }
                }

            }
        }
        setDataTable(filterData);
    }

    // handle checked rows for delete
    const handleCheckBox = (e) => {
        const id = e.target.getAttribute('data-parent');
        const row = document.getElementById(id);
        // if the action is uncheck
        if (row.classList['value'] !== '') {
            row.classList.remove('checked-tr');
            row.childNodes[0].classList.remove('checked-td-tr');
            setCheckData(checkData.filter((r) => r !== e.target.attributes['name'].nodeValue));
        }
        // if the action is check
        else{
            row.classList.add('checked-tr');
            row.childNodes[0].classList.add('checked-td-tr');
            setCheckData((prevState) => [...prevState, e.target.attributes['name'].nodeValue]);
        }
    }

    // save fields of selected row
    const handleEdit = (e) => {
        setEditRow([]);
        let fields = [];
        let row = {};
        const keys = e.target.parentElement.parentElement.id.split("_");
        for (let i = 0; i < initData.length ; i++) {
            if (initData[i].tag_id == keys[0] && initData[i].campaign_id == keys[1]) {
                row = initData[i];
            }
        }
        for (let col in columns){
            fields.push(row[columns[col].field])
        }
        setEditRow(fields);
        setEditModal(true);
    }

    // add row to data
    const handleAdd = async (e) => {
        e.preventDefault();
        let message = "";
        const form = e.target;
        let formData = new FormData();
        for(let i=0; i< form.length-1; i++){
            formData.append(form[i].name, form[i].value);
        }
        formData.append("js_to_inject", "");
        formData.append("missing_lines", "");
        debugger;
        const status = await createVideos(formData);
        if (status === 'success'){
            message = "Tag " + formData.get("tag_id") + " added successfully!"
        }
        else{
            message = "There were problem in the process. \n Please try again"
        }
        setTxtMessage(message);
        setModal(true);
        setButtonText("OK");
    }



    //delete checked rows
    const confirmDeleteRows = async() => {
        if (checkData.length !== 0) {
            setTxtMessage("You are about to delete the selected rows \n are you sure?");
            setModal(true);
            setButtonText("CONFIRM");
        }
    }

  return !!initData? (
    <div className="table-page">
        <div className="logo-container">
            <img src="https://marketing-emails-images.s3.amazonaws.com/Generator/AdMaven_Logo_Gradient.svg" className="logo" alt="description"></img>
        </div>
        <h1 className="title">
            VIDEOS TABLE
        </h1>
        <div className="filter">
                <span className="field-label">Search:</span>
                <input className="field-input" onChange={(e) => {filterTable(e)}}></input>
        </div>
        <div className="table-container">
            <table>
                <thead>
                    <tr>
                    <th className="th-highlight"></th>
                    <th></th>
                    {columns.map((col) => (
                        <th>
                            <span>{col.header}</span>
                            <span name="ASC" onClick={(e) => {sortTable(e,col.field)}} className="sort"> ⬆ </span>
                            <span name="DESC" onClick={(e) => {sortTable(e,col.field)}} className="sort"> ⬇ </span>
                        </th>
                    ))}
                    </tr>
                </thead>
                <tbody>
                    {dataTable.map((row) => (
                    <tr id={row.tag_id.toString()+"_"+row.campaign_id.toString()}>
                        <td className="tr-highlight"></td>
                        <td className="td-input"><input name={row.tag_id} type="checkbox" data-parent={row.tag_id.toString()+"_"+row.campaign_id.toString()} onClick={(e) => {handleCheckBox(e)}}></input></td>
                        <td>{row.tag_id}</td>
                        <td>{row.campaign_id}</td>
                        <td>{row.content}</td>
                        {/* <td>{row.head_content}</td> */}
                        <td>{row.selector}</td>
                        {/* <td>{row.js_to_inject}</td> */}
                        <td>{row.inject_type}</td>
                        <td>{row.url}</td>
                        {/* <td>{row.ads_txt}</td>
                        <td>{row.missing_lines}</td> */}
                        <td className="edit-cell"> <span onClick={(e) => {handleEdit(e)}}> Edit </span> <img src="https://flyclipart.com/thumb2/edit-png-icon-free-download-728148.png" className="edit-logo" alt="description"/></td>
                    </tr>
                    ))}
                </tbody>
            </table>
        </div>
        <div className="delete-container">
            <button className="btn-delete" onClick={confirmDeleteRows}> Delete checked rows </button>
        </div>
        <div className="add-container">
            <h2>add new video tag</h2>
            <form className="add-form" onSubmit={(e)=> handleAdd(e)}>
                <div className="add-field">
                    <label className="field-label">
                        Tag id
                    </label>
                    <input type="text" className="field-input" name="tag_id" required/>
                </div>
                <div className="add-field">
                    <label className="field-label">
                        Campaign id
                    </label>
                    <input type="text" className="field-input" name="campaign_id" required/>
                </div>
                <div className="add-field">
                    <label className="field-label">
                        URL
                    </label>
                    <input type="text" className="field-input" name="url"/>
                </div>
                <div className="add-field">
                    <label className="field-label">
                        Head content
                    </label>
                    <input type="text" className="field-input" name="head_content"/>                
                </div>
                <div className="add-field">
                    <label className="field-label">
                        Selector
                    </label>
                    <input type="text" className="field-input" name="selector"/>
                </div>
                <div className="add-field">
                    <label className="field-label">
                        Inject type
                    </label>
                    <select className="field-input" name="inject_type" required>
                        <option value=""></option>
                        <option value="vanilla">vanilla</option>
                        <option value="window.domcontentloaded">window.domcontentloaded</option>
                        <option value="js">js</option>
                        <option value="window.load">window.load</option>
                    </select>
                </div>
                <div className="add-field">
                    <label className="field-label">
                        Adstxt
                    </label>
                    <select className="field-input" name="adstxt" required>
                        <option value=""></option>
                        <option value="1">1</option>
                        <option value="0">0</option>
                    </select>
                </div>
                <div className="add-field">
                    <label className="field-label">
                        Content
                    </label>
                    <textarea type="text" className="edit-input-content" name="content"/>
                </div>
                <div className="add-button">
                    <button className="btn-create">CREATE</button>
                </div>
            </form>
        </div>

        {/* EDIT MODAL*/}
        <EditModal
            open = {editModal}
            data = {editRow}
        >
        </EditModal>

        {/* REQUEST MODAL*/}
        <RequestModal
            open = {modal}
            text = {txtMessage}
            button = {buttonText}
            data = {checkData}
        >
        </RequestModal>
    </div>
) : (
    <div className="table-page">
        <div className="loading">
            <span className="loading-text">LOADING</span>
            <img className="loading-gif" src={require("../../assets/loading.gif")} alt="description"></img>
        </div>
  </div>

);   
} export default VideosTable;